// Funções genéricas de apoio a cálculos financeiros

const toBoolean = (value) => {
    if (typeof value === "boolean") return value; // Já é booleano
    if (typeof value === "string") return value.toLowerCase() === "true"; // String "true" ou "false"
    return false; // Valor não reconhecido, padrão para false
};

/**
 * Converte número/decimal em centavos inteiros.
 */
const toCents = (n) => Math.round(Number(n || 0) * 100);

/**
 * Converte centavos inteiros em número decimal.
 * @param {number} c - valor em centavos
 * @param {number} casasDecimais - padrão 2
 */
const fromCents = (c, casasDecimais = 2) => Number((c / 100).toFixed(casasDecimais));

/**
 * Converte string "pt-BR" (ex: "1.234,56") em número.
 */
const toNumberBR = (v) => {
    if (v == null) return 0;
    if (typeof v === "number") return Number.isFinite(v) ? v : 0;

    const s = String(v).trim();
    if (!s) return 0;

    const normalized = s
        .replace(/\s/g, "")
        .replace(/\./g, "") // milhar
        .replace(",", "."); // decimal

    const n = Number(normalized);
    return Number.isFinite(n) ? n : 0;
};

/**
 * Arredonda número com precisão segura.
 */
const round = (n, casas = 2) => Number(Number(n || 0).toFixed(casas));

function round2(n) {
    return Math.round((Number(n) + Number.EPSILON) * 100) / 100;
}

const nz = (v, d = 0) => (v == null || v === "" || isNaN(v) ? d : Number(v));

// Lê um conjunto de possíveis chaves numéricas do item (se existirem) e soma
const sumKnownKeys = (obj, keys = []) => keys.reduce((acc, k) => acc + nz(obj?.[k]), 0);

const refreshMovimentoByUuid = async ({ MovimentoAPI, uuid }) => {
    if (!uuid) return null;

    // ✅ A ideia é: buscar o movimento "completo" para re-hidratar as grids.
    // Troque para o endpoint real do seu backend.
    const res = await MovimentoAPI.movimentoByUuid(uuid);

    // aceita res ou res.data
    const mov = res?.data ?? res ?? null;
    if (!mov) return null;

    // normaliza nomes comuns (caso backend use outro padrão)
    const movimentoItems = mov?.movimentoItems ?? mov?.MovimentoItems ?? mov?.movimento_items ?? [];
    const assinaturas = mov?.movimentoAssinaturas ?? mov?.movimento_assinaturas ?? mov?.assinaturas ?? [];

    return {
        mov,
        movimentoItems: Array.isArray(movimentoItems) ? movimentoItems : [],
        assinaturas: Array.isArray(assinaturas) ? assinaturas : [],
    };
};

export {
    toBoolean,
    toCents,
    fromCents,
    toNumberBR,
    round,
    round2,
    nz,
    sumKnownKeys,
    //utilizados no movimento modules
    refreshMovimentoByUuid,
};
